import { AxiosResponse } from "axios";
import { DeviceId } from "src/ui/containers/dashboard/devices/types";

import HttpService from "./httpService";
import RouteService from "./routeService";

interface VncSessionResponse {
    message: string;
    details: {
        message: string;
        type: string;
    }[];
    model: {
        type: string;
        host: string;
        token: string;
    };
}

export const createNvcSession = async (deviceId: DeviceId): Promise<AxiosResponse<VncSessionResponse>> => {
    const endpoint = await RouteService.getDevicesRoute();
    return HttpService.post(endpoint + `${deviceId}/sessions/vnc`);
};
